import React from "react";
import { InnovationUI } from "components";

const Innovation = () => {
  return (
    <>
      <InnovationUI />
    </>
  );
};

export { Innovation };
